export default __webpack_public_path__ + "static/media/340.28958778.gif";